import auth from './vi-VN/auth';
import button from './vi-VN/button';
import error from './vi-VN/error';
import errorCode from './vi-VN/errorCode';
import global from './vi-VN/global';

export default {
  ...auth,
  ...button,
  ...error,
  ...errorCode,
  ...global,
};
